import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Timezone } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useTimezonesQuery(
	options?: Omit<UseQueryOptions<Timezone[], unknown, Timezone[]>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Lookups.Timezones,
		() => AxiosUtils.getResponseData<Timezone[]>(api.get(CerebroApiEndpoints.Lookups.Timezones)),
		options
	);
}
